import { useEffect, useRef, useState } from "react"
import Webcam from "react-webcam"

export type Status = "on" | "off" | "blocked"
export type Violation = "noFace"

type Props = {
  disabled?: boolean
}

export const releaseMediaControl = (stream: MediaStream) => {
  stream.getTracks().forEach(track => track.stop())
}

type CameraStatus =
  | {
      status: Exclude<Status, "off" | "blocked">
      stream: MediaStream
    }
  | {
      status: Exclude<Status, "on">
      stream?: undefined
    }

export const getCameraPermission: (options?: {
  initiate?: boolean
}) => Promise<CameraStatus> = async options => {
  let stream: MediaStream

  if (options?.initiate) {
    try {
      stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
      })
      return { status: "on", stream }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      console.error("Camera permission blocked")
      return { status: "blocked" }
    }
  }

  const devices = await navigator.mediaDevices.enumerateDevices()

  if (
    devices
      .filter(({ kind }) => kind === "videoinput")
      .some(({ label }) => label === "")
  ) {
    return { status: "blocked" }
  } else {
    /**
     * Phone does not allow to re-initiate this request
     */
    // if (isMobile) {
    //   return { status: "on", stream: stream }
    // } else {

    // }
    try {
      stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
      })
      return { status: "on", stream: stream }
    } catch {
      return { status: "blocked" }
    }
  }
}

export function useCamDetection({ disabled }: Props = { disabled: false }) {
  const [webCamStatus, setWebCamStatus] = useState<Status | null>(null)

  const videoRef = useRef<Webcam>(null)

  useEffect(() => {
    const monitorPermissionState = async () => {
      if (navigator.permissions && navigator.permissions.query) {
        try {
          const permission = await navigator.permissions.query({
            name: "camera" as PermissionName,
          })
          if (permission.state === "granted") {
            setWebCamStatus("on")
          } else {
            setWebCamStatus("off")
          }
        } catch (error) {
          // Silently fail if permissions.query() is not supported or throws TypeError
          // This can happen in browsers like Firefox that don't support querying camera permissions
          console.error("Error querying camera permission:", error)
          // Fall back to checking via getUserMedia in the other effect
        }
      }
    }

    setInterval(() => {
      if (!disabled) {
        monitorPermissionState()
      }
    }, 2000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // useEffect(() => {
  //   let getPermissionsInterval: ReturnType<typeof setInterval>

  //   const requestCam = async () => {
  //     const camera = await getCameraPermission({ initiate: true })
  //     setWebCamStatus(camera.status)
  //     // Check camera permissions every 20 seconds
  //     getPermissionsInterval = setInterval(() => {
  //       if (webCamStatus !== "on")
  //         getCameraPermission().then(camera => setWebCamStatus(camera.status))
  //     }, 20 * 1000)
  //   }

  //   if (!disabled && webCamStatus !== "on") {
  //     requestCam()
  //   }

  //   return () => {
  //     clearInterval(getPermissionsInterval)
  //   }
  // }, [disabled, webCamStatus])

  return {
    webCamStatus,
    videoRef,
  } as const
}
